import { render, staticRenderFns } from "./RankingsByMatchdayFile.vue?vue&type=template&id=5b515b2f&scoped=true"
import script from "./RankingsByMatchdayFile.vue?vue&type=script&lang=js"
export * from "./RankingsByMatchdayFile.vue?vue&type=script&lang=js"
import style0 from "./RankingsByMatchdayFile.vue?vue&type=style&index=0&id=5b515b2f&prod&lang=scss"
import style1 from "./RankingsByMatchdayFile.vue?vue&type=style&index=1&id=5b515b2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b515b2f",
  null
  
)

export default component.exports